import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
    return (
        <a
            href="https://wa.me/917879055123?text=Hello%20I%20want%20admission%20details"
            target="_blank"
            rel="noreferrer"
            style={styles.whatsappFloat}
        >
            <FaWhatsapp />
        </a>
    );
}

const styles = {
    whatsappFloat: {
        position: "fixed",
        width: "50px",
        height: "50px",
        bottom: "20px",
        right: "20px",
        backgroundColor: "#25d366",
        color: "#fff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "30px",
        boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",
        zIndex: 9999,
        cursor: "pointer",
    },
};